// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_INVENTORY_CATEGORY,
	SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS,
	SETTING_UPDATE_INVENTORY_CATEGORY,
	SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS,
	SETTING_LOAD_INVENTORY_CATEGORY,
	SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS,
	SETTING_DELETE_INVENTORY_CATEGORY,
	SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_INVENTORY,
	SETTING_LOAD_INVENTORY_SUCCESS,
	SETTING_CREATE_INVENTORY,
	SETTING_CREATE_INVENTORY_SUCCESS,
	SETTING_UPDATE_INVENTORY,
	SETTING_UPDATE_INVENTORY_SUCCESS,
	SETTING_DELETE_INVENTORY,
	SETTING_DELETE_INVENTORY_SUCCESS,
	// SETTING_UPDATE_INVENTORY_STATUS,
	// SETTING_UPDATE_INVENTORY_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	inventoryCategoryLoading: false,
	inventoryLoading: false,
	inventoryCategory: [],
	optionInventoryCategory: [],
	inventory: [],
	optionInventory: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_INVENTORY_CATEGORY:
			return { ...state, inventoryCategoryLoading: true, }
		case SETTING_LOAD_INVENTORY_CATEGORY_SUCCESS:
			return {
				...state,
				inventoryCategoryLoading: false,
				inventoryCategory: action.payload,
				optionInventoryCategory: action.payloadlist
			}
		case SETTING_CREATE_INVENTORY_CATEGORY:
			return { ...state, inventoryCategoryLoading: true }
		case SETTING_CREATE_INVENTORY_CATEGORY_SUCCESS:
			return { ...state, inventoryCategoryLoading: false }
		case SETTING_UPDATE_INVENTORY_CATEGORY:
			return { ...state, inventoryCategoryLoading: true }
		case SETTING_UPDATE_INVENTORY_CATEGORY_SUCCESS:
			return { ...state, inventoryCategoryLoading: false }
		case SETTING_DELETE_INVENTORY_CATEGORY:
			return { ...state, inventoryCategoryLoading: true }
		case SETTING_DELETE_INVENTORY_CATEGORY_SUCCESS:
			return { ...state, inventoryCategoryLoading: false }
		case SETTING_LOAD_INVENTORY:
			return { ...state, inventoryLoading: true, }
		case SETTING_LOAD_INVENTORY_SUCCESS:
			return {
				...state,
				inventoryLoading: false,
				inventory: action.payload,
				optionInventory: action.payloadlist
			}
		case SETTING_CREATE_INVENTORY:
			return { ...state, inventoryLoading: true }
		case SETTING_CREATE_INVENTORY_SUCCESS:
			return { ...state, inventoryLoading: false }
		case SETTING_UPDATE_INVENTORY:
			return { ...state, inventoryLoading: true }
		case SETTING_UPDATE_INVENTORY_SUCCESS:
			return { ...state, inventoryLoading: false }
		case SETTING_DELETE_INVENTORY:
			return { ...state, inventoryLoading: true }
		case SETTING_DELETE_INVENTORY_SUCCESS:
			return { ...state, inventoryLoading: false }
		// case SETTING_UPDATE_INVENTORY_STATUS:
		// 	return { ...state, inventoryLoading: true }
		// case SETTING_UPDATE_INVENTORY_STATUS_SUCCESS:
		// 	return { ...state, inventoryLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				inventoryCategoryLoading: false,
				inventoryLoading: false,
				inventoryCategory: [],
				optionInventoryCategory: [],
				inventory: [],
				optionInventory: [],
			};

		default: return { ...state };
	}
}